import { Heart, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#1E293B] text-white pt-16 pb-8 mt-16" data-testid="site-footer">
      <div className="container-x">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/assets/logo.jpeg" alt="Logo" className="w-14 h-14 rounded-xl object-contain" />
              <div>
                <div className="font-display font-black text-lg text-[#FFD600]">مهرجان العودة للمدارس</div>
                <div className="text-xs text-white/70 font-semibold">Back to School Festival — Libya</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-white/80 leading-relaxed">
              مهرجان سنوي للأطفال في ليبيا يحتفي بالعودة إلى المدارس بأنشطة ومسابقات وورش تفاعلية.
            </p>
          </div>

          <div>
            <h4 className="font-display font-black text-[#FFD600] mb-4">تواصل معنا</h4>
            <ul className="space-y-3 text-sm text-white/85 font-semibold">
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#FFD600]" /> طرابلس — ليبيا</li>
              <li>
                <a href="tel:+218931595551" className="flex items-center gap-3 hover:text-[#FFD600] transition-colors" data-testid="contact-phone-1">
                  <Phone className="w-4 h-4 text-[#FFD600]" /> <span dir="ltr">0931595551</span>
                </a>
              </li>
              <li>
                <a href="tel:+218910793700" className="flex items-center gap-3 hover:text-[#FFD600] transition-colors" data-testid="contact-phone-2">
                  <Phone className="w-4 h-4 text-[#FFD600]" /> <span dir="ltr">0910793700</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-black text-[#FFD600] mb-4">تواريخ المهرجان</h4>
            <div className="flex gap-2">
              {["17", "18", "19"].map((d) => (
                <div key={d} className="w-14 h-14 rounded-2xl bg-white/10 border border-white/20 flex flex-col items-center justify-center">
                  <span className="font-display font-black text-2xl text-[#FFD600]">{d}</span>
                  <span className="text-[10px] text-white/70 font-bold">سبتمبر</span>
                </div>
              ))}
            </div>
            <div className="mt-3 inline-flex items-center gap-2 text-xs font-black text-[#FFD600]">
              ⏰ يوميًا من 5 مساءً إلى 8 مساءً
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div className="flex items-center gap-1">
            صُنِع بـ <Heart className="w-3.5 h-3.5 text-[#E63946] fill-[#E63946]" /> للأطفال في ليبيا
          </div>
          <div className="flex items-center gap-4">
            <a
              href="/admin"
              className="text-white/25 hover:text-[#FFD600] transition-colors text-[10px] font-semibold tracking-wide"
              data-testid="footer-admin-link"
              title="لوحة المشرف"
            >
              · دخول المشرف ·
            </a>
            <span>© 2026 مهرجان العودة للمدارس. جميع الحقوق محفوظة.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
